import { useDispatch } from "react-redux";
import { TaskType } from "./constants";
import Task from "./Task";
import { AppDispatch } from "../../redux/store";
import { setSelectedTask, setShowTaskModal } from "../../redux/slices/taskSlice";
import classNames from "classnames";
import { AddCircleRounded } from "@mui/icons-material";
import Typography from "@mui/material/Typography";

type TaskListProps = {
  tasks: TaskType[];
  isSmallScreen: boolean;
};

const TaskList = ({ tasks, isSmallScreen }: TaskListProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleSelectTask = (task: TaskType) => {
    dispatch(setSelectedTask(task));
    dispatch(setShowTaskModal(true));
  };

  return (
    <>
      {tasks.length === 0 && (
        <div className="min-h-screen flex items-center justify-center" onClick={() => dispatch(setShowTaskModal(true))}>
          <div className="flex flex-col items-center justify-center text-center">
            <AddCircleRounded className="!fill-tgpt-secondary-states-focus !h-[90px] !w-[90px]" />
            <Typography
              variant="h6/medium-500"
              className="text-mui-black-60 dark:text-mui-white-70"
            >
              You have no scheduled tasks.
            </Typography>
          </div>
        </div>
      )}
      {tasks.length > 0 && (
        <div className={classNames({
          "grid grid-cols-3 gap-4": !isSmallScreen,
          "flex flex-col gap-y-4": isSmallScreen,
        })}
        >
          {tasks.map(task => (
            <div onClick={() => handleSelectTask(task)} key={task.id}>
              <Task task={task} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default TaskList;
